import * as types from "../actions/viewConciergeTypes";


  const initialState = {
    concierges: [],
    loading: false,
    error: null,
  };
  
  const viewConciergeReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.FETCH_CONCIERGE_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case types.FETCH_CONCIERGE_SUCCESS:
        return {
          ...state,
          loading: false,
          concierges: action.payload,
        };
      case types.FETCH_CONCIERGE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default viewConciergeReducer;
  